/**
 * Dispatch a typed CustomEvent from a LitElement.
 *
 * @example
 * dispatch(this, 'asc-click', { detail: { value: this.value } });
 */
export function dispatch<T = void>(
  element: HTMLElement,
  eventName: string,
  options: CustomEventInit<T> = {}
): boolean {
  return element.dispatchEvent(
    new CustomEvent<T>(eventName, {
      bubbles: true,
      composed: true,
      cancelable: false,
      ...options,
    })
  );
}
